import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class Stepper extends Component {
  
  render() {
    const { steps, activeStep } = this.props;
    let StepName = steps[activeStep - 1].step

    return (
      <React.Fragment>
        <StepName />
      </React.Fragment>
    );
  }
}

export default withTranslation('translations')(Stepper);
